import { Center, Loader } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getRptSalesPerson } from "api/report.service";
import { formatNZD, parseNZDate } from "common/utils";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RptSalesPersons } from "types/model.types";

const SalesPersonPreview: React.FC = () => {
  const [data, setData] = useState<RptSalesPersons>([]);
  const [loading, setLoading] = useState(false);
  const [params] = useSearchParams();
  const dateFrom = params.get("f");
  const dateTo = params.get("t");

  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);

  // default preset
  useEffect(() => {
    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 1);

    const parsedFrom = parseNZDate(dateFrom);
    const parsedTo = parseNZDate(dateTo);

    setFromDate(parsedFrom ?? startOfYear);
    setToDate(parsedTo ?? today);
  }, [dateFrom, dateTo]);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const result = await safeApiCall(getRptSalesPerson(fromDate, toDate));
        if (mounted && result) {
          setData(result?.data ?? []);
        }
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, [fromDate, toDate]);
  const grandTotal = data.reduce((sum, row) => sum + (row.totalSales ?? 0), 0);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }
  return (
    <>
      <div className="sub-title">Sales Person</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Sales Person</th>
            <th className="alignr">Total</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={`${index}-${row.salesPerson}`}>
              <td>{row.salesPerson}</td>
              <td className="alignr">{formatNZD(row.totalSales)}</td>
            </tr>
          ))}
          <tr>
            <th></th>
            <th className="alignr money">{formatNZD(grandTotal)}</th>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default SalesPersonPreview;
